import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { firstValueFrom } from 'rxjs';
import { CampoUtenteDef, CampoUtenteDefEsolver, CampoUtenteDoc } from '../_models/CampoUtenteDef';
import { EntitaCampoUtente } from '../_models/generated/entita-campo-utente';
import { SearchResult } from '../_models/SearchResult';

@Injectable({ providedIn: 'root' })
export class CampiUtenteService {
  private get baseUrl(): string {
    return `${environment.localApiUrl}api/CampiUtente/`;
  }

  constructor(private http: HttpClient) {}

  async getDefinizioni(
    orgId: number,
    soloAttive: boolean = true,
    entita: EntitaCampoUtente = EntitaCampoUtente.ORDINE_VENDITA
  ): Promise<CampoUtenteDef[]> {
    return firstValueFrom(
      this.http.get<CampoUtenteDef[]>(`${this.baseUrl}Definizioni`, {
        params: { orgId: orgId.toString(), entita: entita.toString(), soloAttive: soloAttive.toString() },
      })
    );
  }

  async create(def: CampoUtenteDef): Promise<CampoUtenteDef> {
    return firstValueFrom(this.http.post<CampoUtenteDef>(`${this.baseUrl}Create`, def));
  }

  async update(def: CampoUtenteDef): Promise<CampoUtenteDef> {
    return firstValueFrom(this.http.post<CampoUtenteDef>(`${this.baseUrl}Update`, def));
  }

  async delete(
    orgId: number,
    codice: string,
    entita: EntitaCampoUtente = EntitaCampoUtente.ORDINE_VENDITA
  ): Promise<unknown> {
    return firstValueFrom(
      this.http.get(`${this.baseUrl}Delete`, {
        params: { orgId: orgId.toString(), codice, entita: entita.toString() },
      })
    );
  }

  // Feature 105: catalogo campi utente ESOLVER (vista ZVIEWCAMPIUTENTE, ambito dipendente da entita) già
  // deduplicato server-side rispetto alle definizioni locali (onlyNew su CodiceEsolver).
  async getDefinizioniEsolver(
    orgId: number,
    entita: EntitaCampoUtente = EntitaCampoUtente.ORDINE_PRODUZIONE
  ): Promise<SearchResult<CampoUtenteDefEsolver>> {
    return firstValueFrom(
      this.http.get<SearchResult<CampoUtenteDefEsolver>>(
        `${environment.localApiUrl}api/Esolver/CampiUtenteDefs/${orgId}`,
        { params: { entita: entita.toString() } }
      )
    );
  }

  // Valori dei campi utente presenti in ESOLVER per un documento (sp_GetCampiUtentePerDocumento).
  async getCampiUtenteDoc(orgId: number, idDoc: number): Promise<SearchResult<CampoUtenteDoc>> {
    return firstValueFrom(
      this.http.get<SearchResult<CampoUtenteDoc>>(
        `${environment.localApiUrl}api/Esolver/CampiUtenteDoc/${orgId}/${idDoc}`
      )
    );
  }
}
